import React, { forwardRef, HTMLAttributes, useState } from 'react';

import { twMerge } from 'tailwind-merge';

interface LongTextProps extends HTMLAttributes<HTMLTextAreaElement> {
  isMinimized?: boolean;
}

export const LongText = forwardRef<HTMLTextAreaElement, LongTextProps>(
  ({ className, isMinimized, onChange, ...rest }, ref) => {
    const [hasValue, setHasValue] = useState(false);
    const shouldHide = isMinimized && hasValue;

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const value = e.target.value.trim();
      setHasValue(value !== '');

      if (onChange) {
        onChange(e);
      }
    };

    return (
      <textarea
        ref={ref}
        placeholder='Long answer text'
        className={twMerge(
          'w-full rounded border border-gray-200 bg-white text-sm placeholder-gray-400',
          shouldHide ? 'hidden' : '',
          className
        )}
        rows={6}
        onChange={handleChange}
        {...rest}
      />
    );
  }
);
